/**
 * @author Harshitha.k
 * @description 
 */

import axios from 'axios';
import { Tabs } from 'antd';
import { connect } from 'react-redux';
import React, { useState, useEffect, useRef } from 'react';
import { AddTableButton } from './styles';
import Highlighter from 'react-highlight-words';
import SelectComponent from './SelectComponent';
import localStorage from '../../../utils/localStorage';
import StyledTable from '../../../commons/styles/table';
import { Form, Input, Button, Row, Col, message, Upload, Tooltip } from 'antd';
import { API_MASTERCONFIGURATION, IPAddress, MASTERUPLOAD } from '../../../commons/api';
import {
  DeleteOutlined,
  DownloadOutlined,
  PlusOutlined,
  UploadOutlined,
  SearchOutlined
} from '@ant-design/icons';

const MasterView = (props) => {
  const [masterJSON, setMasterJSON] = useState({});
  const [datasource, setDatasource] = useState([]);
  const [editObject, setEditObject] = useState({});
  const [activeKey, setActiveKey] = useState('1');
  const [Type, setType] = useState();
  const [masterObject, setMasterObject] = useState();
  const [fileName, setFileName] = useState();
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  const hRef = useRef();

  // componentDidMount
  useEffect(() => {
    let masterCode = props.location.pathname.split('/')[4];
    getMasterData(masterCode);
    setMasterJSON(masterCode);
    // eslint-disable-next-line
  }, []);

  // componentDidUpdate
  useEffect(() => {
    let masterCode = props.location.pathname.split('/')[4];
    if (masterCode !== masterJSON) {
      getMasterData(masterCode);
      // setMasterJSON(masterCode); // commented as in original
    }
    // eslint-disable-next-line
  }, [props.location.pathname]);

  // Methods
  const getDatasourceData = async (createAPIObject, type, Type) => {
    let accessToken = localStorage.get('accessToken');
    const SiteId = localStorage.get('currentSite');
    let header = {};
    if (type === 'list') {
      header = {
        method: createAPIObject.method,
        url: `${createAPIObject.url}?SiteId=${SiteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          MasterCode: props.location.pathname.split('/')[4],
          ActionType: 'read',
          Type
        }
      };
    } else if (type === 'create') {
      header = {
        method: 'POST',
        url: `${createAPIObject.url}?SiteId=${SiteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          MasterCode: masterJSON.MasterCode,
          ActionType: 'create',
          Type,
          data: { ...editObject }
        }
      };
    } else if (type === 'update') {
      header = {
        method: createAPIObject.method,
        url: `${createAPIObject.url}?SiteId=${SiteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          MasterCode: masterJSON.MasterCode,
          ActionType: 'update',
          Type,
          data: { ...editObject, SiteId }
        }
      };
    } else if (type === 'delete') {
      header = {
        method: createAPIObject.method,
        url: `${createAPIObject.url}?SiteId=${SiteId}`,
        headers: {
          Authorization: `Bearer ${accessToken}`
        },
        data: {
          MasterCode: masterJSON.MasterCode,
          ActionType: 'delete',
          data: { ...editObject, SiteId },
          Type
        }
      };
    } else {
      header = {};
    }

    return axios(header)
      .then((response) => {
        return response.data;
      })
      .catch(function (err) {
        if (err.response.status === 400 || err.response.status === 500) {
          message.info(err.response.data.message);
        }
      });
  };

  const getMasterData = async (masterCode) => {
    let masterJSONData = await _getMasterData(masterCode);
    let columns =
      masterJSONData && masterJSONData[0] && masterJSONData[0].JSON && masterJSONData[0].JSON.columns
        ? masterJSONData[0].JSON.columns
        : [];
    columns = columns.filter((col) => col.key !== 'Id' && col.key !== 'SiteId');
    masterJSONData = [
      {
        ...(masterJSONData && masterJSONData[0] ? masterJSONData[0] : {}),
        JSON: {
          ...(masterJSONData && masterJSONData[0] && masterJSONData[0].JSON ? masterJSONData[0].JSON : {}),
          columns
        }
      }
    ];
    if (
      masterJSONData &&
      masterJSONData[0] &&
      masterJSONData[0].JSON &&
      masterJSONData[0].JSON.api &&
      masterJSONData[0].JSON.api.read
    ) {
      let datasource = await getDatasourceData(
        masterJSONData[0].JSON.api.read,
        'list',
        masterJSONData[0].Type
      );

      DownloadCompleteData(masterJSONData[0].JSON);
      setMasterJSON(masterJSONData[0].JSON);
      setType(masterJSONData[0].Type || Type);
      setDatasource(datasource);
      setActiveKey('1');
      setMasterObject(masterJSONData);
    }
  };

  const _getMasterData = (MasterCode) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const Object = {
      method: 'GET',
      url: `${API_MASTERCONFIGURATION.GET}?SiteId=${siteId}&MasterCode=${MasterCode}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(Object)
      .then((response) => {
        return response.data;
      })
      .catch(() => {
        return [];
      });
  };

  // const openDrawer = (e, row) => {
  //   e.preventDefault();
  //   setEditObject(row ? row : {});
  //   setVisible(true);
  // };

  const onClose = () => {
    setActiveKey('1');
  };

  // const showDrawer = () => {
  //   setVisible(true);
  //   setEditObject({});
  // };

  const _masterCreateObject = (e, apiObject) => {
    e.preventDefault();
    hRef.current
      .validateFields()
      .then(async () => {
        await getDatasourceData(apiObject, 'create', masterObject[0].Type);
        let datasourceData = await getDatasourceData(
          masterJSON.api.read,
          'list',
          masterObject[0].Type
        );
        setActiveKey('1');
        setDatasource(datasourceData);
        let masterCode = props.location.pathname.split('/')[4];
        getMasterData(masterCode);
      })
      .catch(() => { });
  };

  const _masterUpdateObject = (e, apiObject) => {
    e.preventDefault();
    hRef.current
      .validateFields()
      .then(async () => {
        await getDatasourceData(apiObject, 'update', masterObject[0].Type);
        let datasourceData = await getDatasourceData(
          masterJSON.api.read,
          'list',
          masterObject[0].Type
        );
        setActiveKey('1');
        setDatasource(datasourceData);
      })
      .catch(() => { });
  };

  const _masterDeleteObject = async (e, apiObject) => {
    e.preventDefault();

    await getDatasourceData(apiObject, 'delete', masterObject[0].Type);
    let datasourceData = await getDatasourceData(
      masterJSON.api.read,
      'list',
      masterObject[0].Type
    );
    setActiveKey('1');
    setDatasource(datasourceData);

  };

  const translation = (keyword) => {
    let translationCacheProp = props.translationCache;
    return translationCacheProp && translationCacheProp[keyword] ? translationCacheProp[keyword] : keyword;
  };

  const onInputChange = (e, key) => {
    setEditObject((prev) => ({
      ...prev,
      [key]: e
    }));
  };

  function renderFormItems(formObject, editObject) {
    switch (formObject.widget) {
      case 'input':
        return (
          <Input
            disabled={
              formObject &&
                formObject.disableOnUpdate &&
                editObject &&
                (editObject.Id || formObject.key === 'Id')
                ? formObject.disableOnUpdate
                : false
            }
            value={editObject && editObject[formObject.key] ? editObject[formObject.key] : ''}
            onChange={(e) => onInputChange(e.target.value, formObject.key)}
          />
        );

      case 'select':
        return (
          <SelectComponent
            value={editObject && editObject[formObject.key] ? editObject[formObject.key] : ''}
            column={formObject}
            handleFieldChange={onInputChange}
          />
        );
      default:
        return (
          <Input
            disabled={
              formObject &&
                formObject.disableOnUpdate &&
                editObject &&
                (editObject.Id || formObject.key === 'Id')
                ? formObject.disableOnUpdate
                : false
            }
            value={editObject && editObject[formObject.key] ? editObject[formObject.key] : ''}
            onChange={(e) => onInputChange(e.target.value, formObject.key)}
          />
        );
    }
  }

  const DownloadCompleteData = (masterJSON) => {
    let Site = masterJSON && masterJSON.Type && masterJSON.Type === 'WithoutSiteId' ? 'false' : 'true';
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let payload = {
      url: `${MASTERUPLOAD.DOWNLOAD}?SiteId=${siteId}&TableName=${masterJSON.TableName}&Site=${Site}`,
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(payload)
      .then((response) => {
        setFileName(response.data.file);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const DeleteCompleteData = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let payload = {
      url: `${MASTERUPLOAD.Delete}?SiteId=${siteId}&TableName=${masterJSON.TableName}`,
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    return axios(payload)
      .then((response) => {
        if (response.data && response.data.message) {
          message.success(response.data.message);
          getMasterData(masterJSON.MasterCode);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation('Search')}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation("Search")}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: () => {
      setTimeout(() => searchInput.current.select());
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const siteId = localStorage.get('currentSite');
  const accessToken = localStorage.get('accessToken');
  const onFinishFailed = () => {
    message.error('Please enter mandatory fields');
  };
  const items = [
    {
      key: '1',
      label: translation('List'),
      children: (
        <StyledTable size="small"
          columns={
            masterJSON.columns &&
            Array.isArray(masterJSON.columns) &&
            masterJSON.columns.map((columnData) => {
              return {
                ...columnData,
                dataIndex: columnData.key,
                title: translation(columnData.title),
                render: (text) => (
                  <div>{typeof text === 'boolean' ? text.toString() : text}</div>
                ),
                ...getColumnSearchProps(columnData.key)
              };
            })
          }
          dataSource={datasource && Array.isArray(datasource) ? datasource : []}
          
          pagination={
            datasource && Array.isArray(datasource) && datasource.length > 10
              ? {
                pageSize: '10'
              }
              : false
          }
          locale={{ emptyText: translation('No Data') }}
          onRow={(record) => ({
            onClick: (e) => {
              e.stopPropagation();
              if (hRef.current) {
                hRef.current.setFieldsValue(record);
              }
              setActiveKey('2');
              setEditObject(record ? record : {});
            }
          })}
        />
      )
    },
    {
      key: '2',
      label: translation('Details'),
      children: (
        <div>
          {activeKey && activeKey === '2' ? (
            <>
              <Form layout="vertical" ref={hRef} initialValues={editObject} onFinishFailed={onFinishFailed}>
                <Row gutter={18}>
                  <Col span={16}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        boxSizing: 'border-box'
                      }}
                    >
                      {masterJSON &&
                        masterJSON.columns &&
                        Array.isArray(masterJSON.columns) &&
                        masterJSON.columns.map((masterColumns, index) => {
                          return (
                            <Col key={index} className="gutter-row" span={8}>
                              <Form.Item
                                name={masterColumns.key}
                                key={index}
                                className={'form'}
                                label={masterColumns.title}
                                rules={[{ required: masterColumns.isMandatory }]}
                              >
                                <div>{renderFormItems(masterColumns, editObject)}</div>
                              </Form.Item>
                            </Col>
                          );
                        })}
                    </div>
                  </Col>
                </Row>

                <Button onClick={onClose}>{translation('Cancel')}</Button>
                {editObject && editObject.Id !== undefined ? (
                  <Button
                    style={{ marginLeft: '9px' }}
                    onClick={(e) =>
                      _masterUpdateObject(e, masterJSON.api.update, 'update')
                    }
                    type="primary"
                  >
                    {translation(`Update`)}
                  </Button>
                ) : (
                  <Button
                    style={{ marginLeft: '9px' }}
                    onClick={(e) =>
                      _masterCreateObject(e, masterJSON.api.create, 'create')
                    }
                    type="primary"
                  >
                    {translation(`Create`)}
                  </Button>
                )}
                {editObject && editObject.Id !== undefined ? (
                  <Button
                    style={{ marginLeft: '9px' }}
                    onClick={(e) =>
                      _masterDeleteObject(e, masterJSON.api.delete, 'delete')
                    }
                    type="primary"
                  >
                    {translation(`Delete`)}
                  </Button>
                ) : null}
              </Form>
            </>
          ) : null}
        </div>
      )
    }
  ];

  return (
    <div>
      {masterJSON ? (
        <>
          <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
            <AddTableButton
              type="primary"
              style={{
                marginLeft: '10px'
              }}
              onClick={() => {
                setActiveKey('2');
                setEditObject({});
              }}
            >
              <PlusOutlined />
              {translation('Add New')}
            </AddTableButton>
            {masterObject && masterObject[0] && masterObject[0].Upload ? (
              <Upload
                name="file"
                action={`${MASTERUPLOAD.UPLOAD}?SiteId=${siteId}&TableName=${masterJSON.TableName}`}
                headers={{
                  Authorization: `Bearer ${accessToken}`
                }}
                onChange={(info) => {
                  if (info.file.status === 'done') {
                    message.success(`${info.file.name} file uploaded successfully`);
                    getMasterData(masterJSON.MasterCode);
                  } else if (info.file.status === 'error') {
                    message.error(`${info.file.name} file upload failed.`);
                  }
                }}
                beforeUpload={(file) => {
                  const isCSV = file.type === 'text/csv' || file.name.endsWith('.csv');
                  if (!isCSV) {
                    message.error('You can only upload CSV files!');
                  }
                  return isCSV || Upload.LIST_IGNORE;
                }}
              >
                <Button type="primary" icon={<UploadOutlined />}>Bulk Data Upload</Button>
              </Upload>
            ) : null}
            <Tooltip title={fileName ? 'Download' : 'Error in Download API'}>
              <AddTableButton
                disabled={fileName ? false : true}
                type="primary"
                style={{ marginRight: '10px' }}
              >
                <a href={`${IPAddress.LOCAL}/api/downloads/${fileName}`}>
                  <DownloadOutlined />
                  {translation('Download Complete Data')}
                </a>
              </AddTableButton>
            </Tooltip>

            <AddTableButton
              type="primary"
              style={{
                marginRight: '10px'
              }}
              onClick={() => DeleteCompleteData()}
            >
              <DeleteOutlined />
              {translation('Delete Complete Data')}
            </AddTableButton>
          </div>
          <Tabs
            type="card"
            defaultActiveKey="1"
            activeKey={activeKey}
            onChange={async (newActiveKey) => {
              if (newActiveKey === '2') {
                setActiveKey(newActiveKey);
                setEditObject({});
              }
              if (newActiveKey === '1') {
                let masterCode = props.location.pathname.split('/')[4];
                getMasterData(masterCode);
              }
              setActiveKey(newActiveKey);
            }}
            items={items}
          />
        </>
      ) : null}
    </div>
  );
};




const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache
  };
};

export default connect(mapStateToProps)(MasterView);